import { apiClient, type Paginated } from '@/core/api';
import type {
  RecurringExpense,
  RecurringExpenseInput,
  RecurringExpenseSummary,
  RecurringScope,
} from './types';

export const BASE = '/finance/recurring-expenses/';

export interface RecurringExpenseListParams {
  page?: number;
  search?: string;
  employee?: number;
  category?: string;
  frequency?: string;
  is_active?: boolean;
  scope?: RecurringScope;
  /** Inclusive bounds (`YYYY-MM-DD`) on the template's start date. */
  after?: string;
  before?: string;
  ordering?: string;
}

export async function listRecurringExpenses(
  params: RecurringExpenseListParams = {},
): Promise<Paginated<RecurringExpense>> {
  const { data } = await apiClient.get<Paginated<RecurringExpense>>(BASE, { params });
  return data;
}

export async function getRecurringExpense(id: string | number): Promise<RecurringExpense> {
  const { data } = await apiClient.get<RecurringExpense>(`${BASE}${id}/`);
  return data;
}

export async function createRecurringExpense(
  input: RecurringExpenseInput,
): Promise<RecurringExpense> {
  const { data } = await apiClient.post<RecurringExpense>(BASE, input);
  return data;
}

export async function updateRecurringExpense(
  id: string | number,
  input: Partial<RecurringExpenseInput>,
): Promise<RecurringExpense> {
  const { data } = await apiClient.patch<RecurringExpense>(`${BASE}${id}/`, input);
  return data;
}

export async function deleteRecurringExpense(id: string | number): Promise<void> {
  await apiClient.delete(`${BASE}${id}/`);
}

export async function getRecurringExpenseSummary(
  params: RecurringExpenseListParams = {},
): Promise<RecurringExpenseSummary> {
  const { data } = await apiClient.get<RecurringExpenseSummary>(`${BASE}summary/`, { params });
  return data;
}

export async function generateRecurringExpensesNow(): Promise<{ created: number }> {
  const { data } = await apiClient.post<{ created: number }>(`${BASE}generate-now/`);
  return data;
}
